var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn text-nowrap btn-default btn-icon",class:_vm.variant === 'small' ? 'btn-sm' : '',attrs:{"href":_vm.href}},[_vm._t("default"),_vm._v(" "),_c('ChevronRight',{staticClass:"svg-16 ml-1"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }